import { NDEFType } from "@/constants";
import { NFC_WS_STATUS } from "@/constants/nfc-ws-status";
import { useDisclosure } from "@/hooks";
import { useNFCStore } from "@/states/zustand/nfc";
import { useNotificationStore } from "@/states/zustand/notification";
import { Button, Modal } from "antd";
import { useEffect, useState } from "react";

const ANDROID_APP = import.meta.env.VITE_NFC_ANDROID_APP_ID;
const IOS_APP = import.meta.env.VITE_NFC_IOS_APP_DEEPLINK;

export function WriteNFCDataModal({ user }: { user: Meditator }) {
	const [opened, { toggle, close }] = useDisclosure(false);
	const { reader_status, card_status, ws } = useNFCStore();
	const [loading, setLoading] = useState<boolean>(false);
	const { setNotification, notification, clearNotification } =
		useNotificationStore();

	useEffect(() => {
		if (notification) {
			if (
				notification.type === "success" &&
				notification.message === "Data Written Successfully!"
			) {
				close();
			}
		}
	}, [notification]);

	const onWriteDataToNFC = async () => {
		if (!reader_status) {
			setNotification({
				type: "error",
				message:
					"No NFC reader detected. Please attached NFC reader to your device!",
			});
			return;
		}

		if (!card_status) {
			setNotification({
				type: "error",
				message: "No NFC card detected!",
			});
			return;
		}

		if (!ws) {
			setNotification({
				type: "error",
				message: "No nfc service running!",
			});
			return;
		}

		setLoading(true);
		const ndef_payloads: NDEFPayload[] = [
			{
				data_type: NDEFType.URL,
				content: IOS_APP + `/${user.id}`,
			},
			{
				data_type: NDEFType.APP,
				content: ANDROID_APP,
			},
		];

		ws.send(
			JSON.stringify({
				type: NFC_WS_STATUS.WRITE_DATA,
				payloads: JSON.stringify(ndef_payloads),
			}),
		);

		setLoading(false);
	};

	return (
		<>
			<Button type="link" size="small" onClick={toggle}>
				Write
			</Button>

			<Modal
				open={opened}
				onCancel={toggle}
				width={440}
				title={"Write"}
				classNames={{
					header: "[&>.ant-modal-title]:!text-xl [&>.ant-modal-title]:!text-f80 [&>.ant-modal-title]:!font-poppins",
				}}
				okButtonProps={{
					className: "bg-primary-gradient !font-poppins",
					shape: "round",
					size: "large",
					loading: loading,
				}}
				okText="Confirm"
				onOk={onWriteDataToNFC}
				cancelButtonProps={{
					size: "large",
					type: "text",
					className: "!font-poppins",
					disabled: loading,
				}}
				closable={!loading}
			>
				<p className="font-poppins text-base text-2C py-2">
					Are you sure you want to write{" "}
					<span className="font-bold text-black">
						{user?.book?.bookNo}, {user?.name}
					</span>{" "}
					to this NFC card?
				</p>
			</Modal>
		</>
	);
}
